// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddNewAccount_addNewAccountBtnContainer__TUePH {
	display: flex;
	justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/account/AddNewAccount.module.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,uBAAuB;AACxB","sourcesContent":[".addNewAccountBtnContainer {\n\tdisplay: flex;\n\tjustify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"addNewAccountBtnContainer": `AddNewAccount_addNewAccountBtnContainer__TUePH`
};
export default ___CSS_LOADER_EXPORT___;
